import * as React from 'react';
import classNames from 'classnames';

/**
 * Renders a simple text field wrapper (usually an `<Input />`) with a label.
 */
export class TextField extends React.PureComponent {
    render() {
        const { children, label, suffix, background = true } = this.props;

        return (
            <div className={classNames('custom-text-field', !background && 'custom-text-field--no-background')}>
                {label && <span className="custom-text-field__label">{label}</span>}
                <div className="custom-text-field__input">
                    <div className="custom-text-field__transclude">{children}</div>
                    {suffix && <span className="custom-text-field__suffix">{suffix}</span>}
                </div>
            </div>
        );
    }
}
